export const transportTranslations = {
  // 交通相关翻译
  "transportServices": {
    en: "Transport Services",
    zh: "交通服务"
  },
  "transportServicesTitle": {
    en: "Penang Transport Services",
    zh: "槟城交通服务"
  },
  "transportServicesDesc": {
    en: "Comprehensive transportation solutions for getting around Penang",
    zh: "全面的槟城出行交通解决方案"
  },
  "gettingAroundPenang": {
    en: "Getting Around Penang",
    zh: "槟城交通出行"
  },
  "gettingAroundPenangDesc1": {
    en: "Navigating Penang is easy with a variety of transportation options to suit your needs and budget.",
    zh: "槟城交通便利，提供各种交通选择以满足您的需求和预算。"
  },
  "gettingAroundPenangDesc2": {
    en: "Whether you prefer public transport, ride-hailing services, or renting your own vehicle, Penang Gateway can help you with all your transportation needs.",
    zh: "无论您喜欢公共交通、网约车服务或租赁自己的车辆，槟城门户都可以帮助您解决所有交通需求。"
  },
  "ourTransportServices": {
    en: "Our Transport Services",
    zh: "我们的交通服务"
  },
  "airportPickup": {
    en: "Airport Pickup",
    zh: "机场接机"
  },
  "airportPickupDesc": {
    en: "Convenient airport transfer services to your accommodation in Penang.",
    zh: "便捷的机场接送服务，直达您在槟城的住所。"
  },
  "carRental": {
    en: "Car Rental",
    zh: "汽车租赁"
  },
  "carRentalDesc": {
    en: "Options ranging from economy to luxury vehicles with flexible rental periods.",
    zh: "提供从经济型到豪华车型的选择，租期灵活。"
  },
  "privateDriver": {
    en: "Private Driver",
    zh: "私人司机"
  },
  "privateDriverDesc": {
    en: "Professional drivers who know Penang well for hassle-free travel.",
    zh: "熟悉槟城的专业司机，让您的旅行无忧无虑。"
  },
  "publicTransportGuidance": {
    en: "Public Transport Guidance",
    zh: "公共交通指导"
  },
  "publicTransportGuidanceDesc": {
    en: "Assistance with bus routes, ferry schedules, and other public transport options.",
    zh: "提供巴士路线、渡轮时刻表和其他公共交通选择的帮助。"
  },
  "drivingLicense": {
    en: "Driving License Information",
    zh: "驾驶执照信息"
  },
  "drivingLicenseDesc": {
    en: "Guidance on using your international license or obtaining a local driving permit.",
    zh: "关于使用国际驾照或获取本地驾驶许可的指导。"
  },
  "transportOptions": {
    en: "Transportation Options in Penang",
    zh: "槟城交通选择"
  },
  "publicBuses": {
    en: "Public Buses",
    zh: "公共巴士"
  },
  "publicBusesDesc": {
    en: "Rapid Penang operates a comprehensive network of buses throughout the island and mainland.",
    zh: "Rapid Penang 在岛上和大陆运营着全面的巴士网络。"
  },
  "busInfo": {
    en: "Bus Information",
    zh: "巴士信息"
  },
  "fareRange": {
    en: "Fare: RM1.40 - RM4.00 per trip",
    zh: "票价：每程 RM1.40 - RM4.00"
  },
  "operatingHours": {
    en: "Operating hours: 5:30am - 11:00pm",
    zh: "运营时间：早上5:30 - 晚上11:00"
  },
  "busCard": {
    en: "Rapid Pass or Touch 'n Go card recommended",
    zh: "推荐使用 Rapid Pass 或 Touch 'n Go 卡"
  },
  "busRoutes": {
    en: "Free CAT buses in Georgetown area",
    zh: "乔治城地区免费 CAT 巴士"
  },
  "busFrequency": {
    en: "Frequency: every 15-30 minutes on main routes",
    zh: "频率：主要路线每15-30分钟一班"
  },
  "taxis": {
    en: "Taxis",
    zh: "出租车"
  },
  "taxisDesc": {
    en: "Metered taxis are available, especially in tourist areas and at taxi stands.",
    zh: "计价出租车随处可见，尤其是在旅游区和出租车站。"
  },
  "meteredFares": {
    en: "Metered fares; confirm with driver before starting",
    zh: "计价收费；开始前与司机确认"
  },
  "availableAtStands": {
    en: "Available at taxi stands and can be hailed",
    zh: "可在出租车站找到，也可招手即停"
  },
  "commonInTouristAreas": {
    en: "Common in tourist areas and city centers",
    zh: "在旅游区和市中心很常见"
  },
  "rideHailing": {
    en: "Ride-Hailing Services",
    zh: "网约车服务"
  },
  "rideHailingDesc": {
    en: "Convenient on-demand transport services available via smartphone apps.",
    zh: "通过智能手机应用提供便捷的按需交通服务。"
  },
  "keyInformation": {
    en: "Key Information",
    zh: "重要信息"
  },
  "carRentalsTitle": {
    en: "Car Rentals",
    zh: "汽车租赁"
  },
  "carRentalsDesc": {
    en: "Rent a car for flexibility in exploring Penang at your own pace.",
    zh: "租一辆车，按自己的节奏灵活探索槟城。"
  },
  "majorRentalCompanies": {
    en: "Major international and local rental companies available",
    zh: "提供主要的国际和本地租赁公司"
  },
  "dailyWeeklyRates": {
    en: "Daily, weekly, and monthly rates available",
    zh: "提供日租、周租和月租价格"
  },
  "idpMayBeRequired": {
    en: "International Driving Permit (IDP) may be required for some nationalities",
    zh: "某些国籍可能需要国际驾驶许可证（IDP）"
  },
  "typicalPrices": {
    en: "Typical Prices: RM100-RM300 per day for standard cars",
    zh: "典型价格：标准车型每天 RM100-RM300"
  },
  "insuranceDetails": {
    en: "Insurance: Basic insurance usually included, comprehensive available",
    zh: "保险：通常包含基本保险，可提供综合保险"
  },
  "bookingProcess": {
    en: "Booking Process: Online or direct at rental counters",
    zh: "预订流程：在线或直接在租赁柜台预订"
  },
  "motorcycleRentals": {
    en: "Motorcycle Rentals",
    zh: "摩托车租赁"
  },
  "motorcycleRentalsDesc": {
    en: "A popular and convenient way to navigate through traffic and explore smaller roads.",
    zh: "一种流行且便捷的方式，可在交通中穿梭并探索较小的道路。"
  },
  "popularForExploring": {
    en: "Popular for exploring towns and scenic routes",
    zh: "热门选择，适合探索城镇和风景路线"
  },
  "licenseRequirements": {
    en: "Valid driving license required (often min. 1 year holding)",
    zh: "需要有效驾驶执照（通常至少持有1年）"
  },
  "helmetMandatory": {
    en: "Helmet usage is mandatory",
    zh: "必须佩戴头盔"
  },
  "cycling": {
    en: "Cycling",
    zh: "自行车"
  },
  "cyclingDesc": {
    en: "Explore Georgetown's heritage sites or coastal paths on a bicycle.",
    zh: "骑自行车探索乔治城的文化遗产地或沿海小径。"
  },
  "dedicatedBikeLanes": {
    en: "Dedicated bike lanes in some areas",
    zh: "部分地区设有专用自行车道"
  },
  "bikeSharingServices": {
    en: "Bike-sharing services available in Georgetown",
    zh: "乔治城提供自行车共享服务"
  },
  "idealForShortDistances": {
    en: "Ideal for short distances and leisurely exploration",
    zh: "适合短途和悠闲探索"
  },
  "mostPopularOption": {
    en: "Most popular option",
    zh: "最受欢迎的选择"
  },
  "newAlternative": {
    en: "New alternative with negotiable fares",
    zh: "新选择，票价可协商"
  },
  "priceEstimates": {
    en: "Price estimates shown before booking",
    zh: "预订前显示价格估计"
  },
  "paymentMethods": {
    en: "Cash or digital payment options",
    zh: "现金或数字支付选项"
  },
  "appDownload": {
    en: "App download required",
    zh: "需要下载应用"
  },
  "bicyclesAndEScooters": {
    en: "Bicycles & E-Scooters",
    zh: "自行车和电动滑板车"
  },
  "bicyclesAndEScootersDesc": {
    en: "Eco-friendly options for exploring the city, especially in Georgetown's heritage area.",
    zh: "探索城市的环保选择，尤其适合乔治城的文化遗产区。"
  },
  "rentalRates": {
    en: "Bicycle rental: RM10-30 per day",
    zh: "自行车租赁：每天 RM10-30"
  },
  "eScootersAvailability": {
    en: "E-scooters available in select areas",
    zh: "特定区域提供电动滑板车"
  },
  "cyclingLanes": {
    en: "Cycling lanes in some parts of the city",
    zh: "城市部分地区设有自行车道"
  },
  "helmetRequirement": {
    en: "Helmets recommended for safety",
    zh: "为安全起见建议戴头盔"
  },
  "airportTransfers": {
    en: "Airport Transfers",
    zh: "机场接送"
  },
  "airportTransfersDesc": {
    en: "Options for traveling between Penang International Airport and your destination.",
    zh: "在槟城国际机场和您的目的地之间旅行的选择。"
  },
  "transferOptions": {
    en: "Transfer Options",
    zh: "接送选择"
  },
  "airportBuses": {
    en: "Airport buses (Route 401, 401E)",
    zh: "机场巴士（路线 401、401E）"
  },
  "privateCars": {
    en: "Private car services (pre-book)",
    zh: "私家车服务（提前预订）"
  },
  "shuttleServices": {
    en: "Hotel shuttle services",
    zh: "酒店穿梭巴士服务"
  },
  "taxisAtAirport": {
    en: "Taxis from airport counters",
    zh: "机场柜台出租车"
  },
  "ferryAndBridge": {
    en: "Ferry & Bridge Connections",
    zh: "渡轮和桥梁连接"
  },
  "ferryAndBridgeDesc": {
    en: "Options for traveling between Penang Island and the mainland.",
    zh: "在槟城岛和大陆之间旅行的选择。"
  },
  "ferryService": {
    en: "Ferry service: Georgetown to Butterworth",
    zh: "渡轮服务：乔治城至北海"
  },
  "firstBridge": {
    en: "Penang Bridge (13.5km) - Free to island",
    zh: "槟威大桥（13.5公里） - 进岛免费"
  },
  "secondBridge": {
    en: "Second Bridge (24km) - Southern route",
    zh: "第二大桥（24公里） - 南线路线"
  },
  "bridgeToll": {
    en: "Toll charges apply when leaving island",
    zh: "离岛时收取通行费"
  },
  "drivingInPenang": {
    en: "Driving in Penang",
    zh: "在槟城驾驶"
  },
  "drivingRequirements": {
    en: "Driving Requirements",
    zh: "驾驶要求"
  },
  "drivingRequirementsDesc": {
    en: "What you need to know before driving in Penang:",
    zh: "在槟城驾驶前需要了解的事项："
  },
  "validLicense": {
    en: "Valid driving license from your home country",
    zh: "您所在国家/地区的有效驾驶执照"
  },
  "internationalLicense": {
    en: "International Driving Permit recommended",
    zh: "建议持有国际驾驶许可证"
  },
  "licenseConversion": {
    en: "License conversion for stays over 3 months",
    zh: "停留超过3个月需要驾照转换"
  },
  "minimumAge": {
    en: "Minimum age: 18 years for cars, 16 for motorcycles",
    zh: "最低年龄：汽车18岁，摩托车16岁"
  },
  "roadRules": {
    en: "Road Rules",
    zh: "道路规则"
  },
  "driveOnLeft": {
    en: "Drive on the left side of the road",
    zh: "靠左行驶"
  },
  "speedLimits": {
    en: "Speed limits: 50-70km/h in cities, 90-110km/h on highways",
    zh: "速度限制：城市内50-70公里/小时，高速公路上90-110公里/小时"
  },
  "seatbelts": {
    en: "Seatbelts mandatory for all passengers",
    zh: "所有乘客必须系安全带"
  },
  "zeroTolerance": {
    en: "Zero tolerance for drunk driving",
    zh: "对酒后驾车零容忍"
  },
  "parkingInPenang": {
    en: "Parking in Penang",
    zh: "槟城停车"
  },
  "parkingInPenangDesc": {
    en: "Understanding the parking system in Penang:",
    zh: "了解槟城的停车系统："
  },
  "couponSystem": {
    en: "Coupon parking system in many areas",
    zh: "许多地区采用优惠券停车系统"
  },
  "paidParking": {
    en: "Paid parking in most urban areas",
    zh: "大多数城市地区为收费停车"
  },
  "illegallyParked": {
    en: "Illegally parked vehicles may be clamped/towed",
    zh: "违规停放的车辆可能被锁车/拖走"
  },
  "freeParking": {
    en: "Free parking at some shopping malls (with purchase)",
    zh: "某些购物中心提供免费停车（需购物）"
  },
  "navigationTips": {
    en: "Navigation Tips",
    zh: "导航提示"
  },
  "trafficConditions": {
    en: "Traffic Conditions",
    zh: "交通状况"
  },
  "trafficConditionsDesc": {
    en: "Be aware of peak hour traffic, especially on the Penang Bridge and in Georgetown.",
    zh: "请注意高峰时段的交通状况，尤其是在槟威大桥和乔治城市区。"
  },
  "publicTransportEtiquette": {
    en: "Public Transport Etiquette",
    zh: "公共交通礼仪"
  },
  "publicTransportEtiquetteDesc": {
    en: "Offer seats to elderly and pregnant women. Keep noise levels down.",
    zh: "为老人和孕妇让座。保持低音量。"
  },
  "useNavigationApps": {
    en: "Use navigation apps (Google Maps, Waze)",
    zh: "使用导航应用（谷歌地图，Waze）"
  },
  "oneWayStreets": {
    en: "Many one-way streets in Georgetown",
    zh: "乔治城有许多单行道"
  },
  "rushHours": {
    en: "Rush hours: 7:30-9:30am, 5:30-7:30pm",
    zh: "高峰时段：早上7:30-9:30，下午5:30-7:30"
  },
  "flooding": {
    en: "Some areas prone to flooding during heavy rain",
    zh: "大雨期间某些地区容易发生水浸"
  },
  "needTransportAssistance": {
    en: "Need Transport Assistance?",
    zh: "需要交通协助？"
  },
  "transportAssistanceDesc": {
    en: "Our transport specialists can arrange airport pickups, car rentals, and provide guidance on getting around Penang efficiently.",
    zh: "我们的交通专家可以安排机场接机、汽车租赁，并提供有关高效游览槟城的指导。"
  },
  "requestTransportService": {
    en: "Request Transport Service",
    zh: "申请交通服务"
  },
  "airportPickupRequest": {
    en: "Airport Pickup Request",
    zh: "机场接机申请"
  },
  "yourName": {
    en: "Your Name",
    zh: "您的姓名"
  },
  "yourEmail": {
    en: "Your Email",
    zh: "您的电子邮箱"
  },
  "flightNumber": {
    en: "Flight Number",
    zh: "航班号"
  },
  "arrivalDateAndTime": {
    en: "Arrival Date & Time",
    zh: "到达日期和时间"
  },
  "destinationInPenang": {
    en: "Destination in Penang",
    zh: "槟城目的地"
  },
  "numberOfPassengers": {
    en: "Number of Passengers",
    zh: "乘客人数"
  },
  "onePerson": {
    en: "1 Person",
    zh: "1人"
  },
  "twoPeople": {
    en: "2 People",
    zh: "2人"
  },
  "threePeople": {
    en: "3 People",
    zh: "3人"
  },
  "fourPeople": {
    en: "4 People",
    zh: "4人"
  },
  "fivePlusPeople": {
    en: "5+ People",
    zh: "5人以上"
  },
  "submitRequest": {
    en: "Submit Request",
    zh: "提交申请"
  },
  "moreInfo": {
    en: "More Information",
    zh: "更多信息"
  },
  "penangTransportationAlt": {
    en: "Penang Transportation",
    zh: "槟城交通"
  }
};
